module.exports = __webpack_public_path__ + "static/media/shoeBack.d56c58a0.png";